export default "__VITE_ASSET__DxFC_RJp__"